// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"618":"4e625e61","1503":"a88472b9","1526":"928cbd28","3422":"948afcf8","8104":"948afcf8","9151":"5e026f5d","9421":"928cbd28"}[chunkId] + ".chunk.css";
};